import C from '../constants'
import { combineReducers } from 'redux'
import sharedReducers from '../../../shared/reducers'

export const photos = (
  state = {
    isFetching: false,
    didInvalidate: false,
    items: []
  },
  action
) => {
  switch (action.type) {
    case C.INVALIDATE_PHOTOS:
      return Object.assign({}, state, {
        didInvalidate: true
      })
    case C.REQUEST_PHOTOS:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      })
    case C.RECEIVE_PHOTOS:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        items: action.photos,
        lastUpdated: action.receivedAt
      })
    default:
      return state
  }
}

export const residents = (
  state = {
    isFetching: false,
    didInvalidate: false,
    items: []
  },
  action
) => {
  switch (action.type) {
    case C.INVALIDATE_RESIDENTS:
      return Object.assign({}, state, {
        didInvalidate: true
      })
    case C.REQUEST_RESIDENTS:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      })
    case C.RECEIVE_RESIDENTS:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        items: action.residents,
        lastUpdated: action.receivedAt
      })
    default:
      return state
  }
}

export const host = (
  state = {
    isFetching: false,
    didInvalidate: false,
    items: []
  },
  action
) => {
  switch (action.type) {
    case C.INVALIDATE_HOST:
      return Object.assign({}, state, {
        didInvalidate: true
      })
    case C.REQUEST_HOST:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      })
    case C.RECEIVE_HOST:
      return Object.assign({}, state, {
        ...action.host,
        isFetching: false,
        didInvalidate: false,
        lastUpdated: action.receivedAt
      })
    default:
      return state
  }
}

export const rooms = (
  state = {
    isFetching: false,
    didInvalidate: false,
    items: []
  },
  action
) => {
  switch (action.type) {
    case C.INVALIDATE_ROOMS:
      return Object.assign({}, state, {
        didInvalidate: true
      })
    case C.REQUEST_ROOMS:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      })
    case C.RECEIVE_ROOMS:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        items: action.rooms,
        lastUpdated: action.receivedAt
      })
    default:
      return state
  }
}

export const address = (state = null, action) => (
  action.type == C.SET_ADDRESS ? action.payload : state
)

export const addressValidations = (state=null, action) => {
  switch (action.type) {
    case C.SET_ADDRESS_VALIDATIONS:
      return action.payload
    default:
      return state
  }
}

export const content = (state=null, action) =>
  (action.type === C.SET_CONTENT) ?
    action.payload :
    state

export const page = (state=null, action) =>
  (action.type === C.SET_PAGE) ?
    action.payload :
    state

export const pages = (state=[], action) =>
  (action.type === C.SET_PAGES) ?
    action.payload :
    state;

export const nextPage = (state=false, action) =>
  (action.type === C.SET_NEXT_PAGE) ?
    action.payload :
    state

export const previousPage = (state=false, action) =>
  (action.type === C.SET_PREVIOUS_PAGE) ?
    action.payload :
    state

export const terms = (state=null, action) =>
  (action.type === C.SET_TERMS) ?
    action.payload :
    state

export const user = (state=null, action) =>
  (action.type === C.SET_USER) ?
  	action.payload :
  	state

export const holding = (state=false, action) =>
  (action.type === C.SET_HOLDING) ?
  	action.payload :
  	state;

export const environment = (state=false, action) =>
  (action.type === C.SET_ENVIRONMENT) ?
  	action.payload :
  	state;

export const proceedFromHolding = (state=false, action) =>
  (action.type === C.SET_PROCEED_FROM_HOLDING) ?
    action.payload :
    state;

export const profileElements = (state=[], action) =>
  (action.type === C.SET_PROFILE_ELEMENTS) ?
    action.payload :
    state;

export const requiredFields = (state=[], action) =>
  (action.type === C.SET_REQUIRED_FIELDS) ?
    action.payload :
    state;

export const localProfileElements = (state=false, action) =>
  (action.type === C.SET_LOCAL_PROFILE_ELEMENTS) ?
    action.payload :
    state;

export const registered = (state=false, action) =>
  (action.type === C.SET_REGISTERED) ?
  	action.payload :
  	state;

export const territory = (state=false, action) =>
  (action.type === C.SET_TERRITORY) ?
  	action.payload :
  	state;

export const market = (state=false, action) =>
  (action.type === C.SET_MARKET) ?
  	action.payload :
  	state;

export const affiliate = (state=false, action) =>
  (action.type === C.SET_AFFILIATE) ?
  	action.payload :
  	state;

export const referralProgram = (state=false, action) =>
  (action.type === C.SET_REFERRAL_PROGRAM) ?
  	action.payload :
  	state;

export const language_options = (state=false, action) =>
  (action.type === C.SET_LANGUAGE_OPTIONS) ?
  	action.payload :
  	state;

export const ethnicity_options = (state=false, action) =>
  (action.type === C.SET_ETHNICITY_OPTIONS) ?
  	action.payload :
  	state;

export const activeProfileElements = (state=false, action) =>
  (action.type === C.SET_ACTIVE_PROFILE_ELEMENTS) ?
  	action.payload :
  	state;

export const withdrawn = (state=false, action) =>
  (action.type === C.SET_WITHDRAWN) ?
  	action.payload :
  	state;

export const completed = (state=false, action) =>
  (action.type === C.SET_COMPLETED) ?
  	action.payload :
  	state

export const uploader = (state = {}, action) => {
  switch (action.type) {
    case C.SET_UPLOAD_PROGRESS:
      return { ...state, progress: action.payload.progress }
    case C.SET_UPLOAD_STATUS:
      return { ...state, status: action.payload.status }
    case C.RESET_UPLOAD:
      return {}
    default:
      return state
  }
}

export const residentVaccinationOptions = (state=[], action) =>
  (action.type === C.SET_RESIDENT_VACCINATION_OPTIONS) ?
    action.payload :
    state;

export const navigationDirection = (state = 'forward', action) => {
  if (action.type === C.SET_NEXT_PAGE && action.payload === true) {
    return 'forward';
  }
  if (action.type === C.SET_PREVIOUS_PAGE && action.payload === true) {
    return 'backward';
  }
  return state;
};

export default combineReducers({
  address,
  addressValidations,
  activeProfileElements,
  content,
  navigationDirection,
  page,
  nextPage,
  previousPage,
  proceedFromHolding,
  profileElements,
  requiredFields,
  localProfileElements,
  environment,
  user,
  holding,
  pages,
  photos,
  registered,
  residents,
  rooms,
  affiliate,
  host,
  territory,
  market,
  terms,
  withdrawn,
  referralProgram,
  language_options,
  ethnicity_options,
  completed,
  uploader,
  residentVaccinationOptions,
  recaptchaSiteId: sharedReducers.recaptchaSiteId,
  vaccinationMandatory: sharedReducers.vaccinationMandatory,
  authenticatedUser: sharedReducers.authenticatedUser
})
